/* zweiherzig – UX-Paket (Okt. 2026)
   1) Schnellkauf: kleine Tasche rechts unten auf jedem Produktbild.
      Ohne Varianten -> direkt in den Warenkorb (Cart-Drawer öffnet sich).
      Mit Varianten  -> Auswahlfenster (Handy: Bottom-Sheet, Desktop: Dialog).
   2) Kollektionstext am Handy einklappen („Mehr lesen“). */
(function () {
  "use strict";
  var EN = (document.documentElement.lang || "de").toLowerCase().indexOf("en") === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var T = EN ? {
    add: "Add to cart", quick: "Quick add", choose: "Choose", details: "View full details",
    close: "Close", added: "Added", soldout: "Sold out", error: "Sorry, that didn't work. Please try again.",
    unavailable: "Not available", more: "Read more +", less: "Show less –"
  } : {
    add: "In den Warenkorb", quick: "Schnell in den Warenkorb", choose: "Auswählen", details: "Zur Produktseite",
    close: "Schließen", added: "Hinzugefügt", soldout: "Ausverkauft", error: "Das hat leider nicht geklappt. Bitte versuch es nochmal.",
    unavailable: "Nicht verfügbar", more: "Mehr lesen +", less: "Weniger –"
  };
  var BAG = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 11.5v5M9.5 14h5"/></svg>';
  var cache = {};

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    /* wie das Shop-Währungsformat „{{amount_with_comma_separator}} €“ (gilt für DE und EN) */
    return v.replace(".", ",") + " €";
  }
  function handleFrom(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }

  /* ---------- Karten ausstatten ---------- */
  function decorate(scope) {
    var cards = (scope || document).querySelectorAll(".card-wrapper:not([data-zqa]), a.zh-card:not([data-zqa])");
    cards.forEach(function (card) {
      card.setAttribute("data-zqa", "1");
      var link = card.matches("a.zh-card") ? card : card.querySelector('a[href*="/products/"]');
      var handle = handleFrom(link && link.getAttribute("href"));
      if (!handle) return;
      if (card.querySelector(".zh-badge--aus") || card.querySelector(".card__badge .badge")) {
        var sold = card.querySelector(".zh-badge--aus, .card__badge .badge");
        if (sold && /ausverkauft|sold out/i.test(sold.textContent)) return;
      }
      var host = card.matches("a.zh-card") ? card.querySelector(".zh-card__media") : card.querySelector(".card__inner");
      if (!host) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "zqa-btn";
      b.setAttribute("aria-label", T.quick + (link ? ": " + link.textContent.trim().replace(/\s+/g, " ") : ""));
      b.setAttribute("data-handle", handle);
      b.innerHTML = BAG;
      host.appendChild(b);
    });
  }

  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest(".zqa-btn");
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();
    quickAdd(b);
  }, true);

  function quickAdd(btn) {
    if (btn.classList.contains("is-busy")) return;
    btn.classList.add("is-busy");
    getProduct(btn.getAttribute("data-handle")).then(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      if (!avail.length) { flash(btn, false); return; }
      if (p.variants.length === 1) {
        return addToCart(p.variants[0].id, btn).then(function () { flash(btn, true); });
      }
      openSheet(p, btn);
    }).catch(function () { flash(btn, false); }).then(function () { btn.classList.remove("is-busy"); });
  }
  function flash(btn, ok) {
    btn.classList.add(ok ? "is-ok" : "is-err");
    setTimeout(function () { btn.classList.remove("is-ok", "is-err"); }, 1600);
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(variantId, origin) {
    var drawer = document.querySelector("cart-drawer");
    var sections = [];
    if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || "error"); return j; }); })
      .then(function (j) {
        if (drawer && drawer.renderContents && j.sections) {
          j.id = variantId;
          drawer.classList.remove("is-empty");
          drawer.renderContents(j);
          if (origin && drawer.setActiveElement) drawer.setActiveElement(origin);
        } else {
          window.location.href = ROOT + "cart";
        }
        try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: "zwh-quick-add", productVariantId: variantId, cartData: j }); } catch (e) {}
        return j;
      });
  }

  /* ---------- Auswahlfenster ---------- */
  var sheet, backdrop, lastFocus;
  function buildSheet() {
    backdrop = document.createElement("div");
    backdrop.className = "zqa-backdrop";
    sheet = document.createElement("div");
    sheet.className = "zqa-sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("tabindex", "-1");
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
    backdrop.addEventListener("click", closeSheet);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sheet.classList.contains("is-open")) closeSheet(); });
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    document.documentElement.classList.remove("zqa-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function openSheet(p, origin) {
    if (!sheet) buildSheet();
    lastFocus = origin;
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var sel = first.options.slice();
    var img = (first.featured_image && first.featured_image.src) || p.featured_image || "";
    if (img && img.indexOf("//") === 0) img = "https:" + img;
    var html = '<button type="button" class="zqa-close" aria-label="' + T.close + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<div class="zqa-head">' + (img ? '<img class="zqa-img" src="' + esc(img) + (img.indexOf("?") > -1 ? "&" : "?") + 'width=240" alt="" width="96" height="120">' : "") +
      '<div class="zqa-meta"><p class="zqa-title" id="zqa-title">' + esc(p.title) + '</p><p class="zqa-price"></p>' +
      '<a class="zqa-link" href="' + esc(ROOT + "products/" + p.handle) + '">' + T.details + "</a></div></div>";
    p.options.forEach(function (opt, i) {
      var name = typeof opt === "string" ? opt : opt.name;
      var values = (typeof opt === "string" ? null : opt.values) || unique(p.variants.map(function (v) { return v.options[i]; }));
      html += '<fieldset class="zqa-opt" data-i="' + i + '"><legend>' + esc(name) + ': <span class="zqa-cur"></span></legend><div class="zqa-pills">';
      values.forEach(function (val) { html += '<button type="button" class="zqa-pill" data-i="' + i + '" data-v="' + esc(val) + '">' + esc(val) + "</button>"; });
      html += "</div></fieldset>";
    });
    html += '<button type="button" class="zqa-add"></button><p class="zqa-msg" role="status" aria-live="polite"></p>';
    sheet.innerHTML = html;
    sheet.setAttribute("aria-labelledby", "zqa-title");

    function current() {
      return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function render() {
      var v = current();
      sheet.querySelectorAll(".zqa-opt").forEach(function (fs) {
        var i = +fs.getAttribute("data-i");
        fs.querySelector(".zqa-cur").textContent = sel[i];
        fs.querySelectorAll(".zqa-pill").forEach(function (b) {
          var val = b.getAttribute("data-v");
          var test = sel.slice(); test[i] = val;
          var match = p.variants.filter(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); })[0];
          b.classList.toggle("is-on", val === sel[i]);
          b.setAttribute("aria-pressed", val === sel[i] ? "true" : "false");
          b.classList.toggle("is-na", !match || !match.available);
        });
      });
      var add = sheet.querySelector(".zqa-add");
      var pr = sheet.querySelector(".zqa-price");
      if (v) {
        pr.innerHTML = money(v.price) + (v.compare_at_price > v.price ? " <s>" + money(v.compare_at_price) + "</s>" : "");
        add.disabled = !v.available;
        add.textContent = v.available ? T.add + " – " + money(v.price) : T.soldout;
      } else {
        add.disabled = true; add.textContent = T.unavailable;
      }
    }
    sheet.querySelectorAll(".zqa-pill").forEach(function (b) {
      b.addEventListener("click", function () { sel[+b.getAttribute("data-i")] = b.getAttribute("data-v"); render(); });
    });
    sheet.querySelector(".zqa-close").addEventListener("click", closeSheet);
    sheet.querySelector(".zqa-add").addEventListener("click", function () {
      var v = current(); if (!v || !v.available) return;
      var add = this; add.disabled = true; add.classList.add("is-busy");
      sheet.querySelector(".zqa-msg").textContent = "";
      addToCart(v.id, origin).then(function () {
        closeSheet(); flash(origin, true);
      }).catch(function (e) {
        sheet.querySelector(".zqa-msg").textContent = (e && e.message && e.message !== "error") ? e.message : T.error;
      }).then(function () { add.disabled = false; add.classList.remove("is-busy"); });
    });
    render();
    document.documentElement.classList.add("zqa-lock");
    backdrop.classList.add("is-open");
    requestAnimationFrame(function () { sheet.classList.add("is-open"); sheet.focus(); });
  }
  function unique(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

  /* ---------- Kollektionstext am Handy einklappen ---------- */
  function clampColText() {
    var t = document.querySelector(".zh-colhead__text");
    if (!t || t.dataset.zclamp) return;
    t.dataset.zclamp = "1";
    if (t.textContent.trim().length < 160) return;
    t.classList.add("zh-clamp");
    var b = document.createElement("button");
    b.type = "button"; b.className = "zh-clamp__btn"; b.textContent = T.more;
    b.setAttribute("aria-expanded", "false");
    b.addEventListener("click", function () {
      var open = t.classList.toggle("is-open");
      b.textContent = open ? T.less : T.more;
      b.setAttribute("aria-expanded", open ? "true" : "false");
    });
    t.insertAdjacentElement("afterend", b);
  }

  function init() {
    decorate(document);
    clampColText();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { decorate(document); break; } }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
